import './ColumnOrderSettingsDragAndDrop.css';
export var columnDndHandle = '_11d1m5j1-3-12-1';
export var columnDndOverlay = '_11d1m5j0-3-12-1';
export var disabledNonTargetLocalColumn = '_11d1m5j2-3-12-1';